import React from 'react';
import { formatRelative } from '../utils/time';

const statusBadgeClass = {
  active: 'badge--success',
  warming: 'badge--info',
  cooling: 'badge--muted',
  inactive: 'badge--warning',
  unknown: 'badge--default'
};

const NetworkRoster = ({
  members,
  selectedMemberId,
  onSelectMember,
  onQuickContact,
  activityByMember
}) => {
  return (
    <div className="network-roster">
      <header>
        <h2>Active Network</h2>
        <p className="network-roster__hint">Tap to edit or log contact.</p>
      </header>
      <ul>
        {members.map((member) => {
          const status = activityByMember.get(member._id) || 'unknown';
          return (
            <li
              key={member._id}
              className={selectedMemberId === member._id ? 'selected' : ''}
            >
              <button type="button" onClick={() => onSelectMember(member)}>
                <div className="network-roster__top">
                  <span className={`badge ${statusBadgeClass[status] || 'badge--default'}`}>
                    {status}
                  </span>
                  <span className="network-roster__name">{member.name}</span>
                </div>
                <div className="network-roster__meta">
                  <span>{member.relationshipToChild}</span>
                  {member.role && <span className="chip chip--muted">{member.role}</span>}
                </div>
                <div className="network-roster__contact">Last contact {formatRelative(member.lastContactAt)}</div>
              </button>
              <div className="network-roster__actions">
                <button type="button" onClick={() => onQuickContact(member)}>
                  Quick Contact
                </button>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default NetworkRoster;
